import { render, staticRenderFns } from "./appDashboard.vue?vue&type=template&id=38bc3d28&scoped=true"
import script from "./appDashboard.vue?vue&type=script&lang=js"
export * from "./appDashboard.vue?vue&type=script&lang=js"
import style0 from "./appDashboard.vue?vue&type=style&index=0&id=38bc3d28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38bc3d28",
  null
  
)

export default component.exports